import { TableCell, TableCellProps, Tooltip } from "@mui/material";
import { useEffect, useRef, useState } from "react";

type EllipsisCellProps = TableCellProps & {
	text: string;
	width?: number;
};

export const EllipsisCell = ({
	text,
	width = 140,
	sx,
	...rest
}: EllipsisCellProps) => {
	const ref = useRef<HTMLSpanElement>(null);
	const [isOverflowing, setIsOverflowing] = useState(false);

	useEffect(() => {
		const el = ref.current;
		if (!el) return;
		setIsOverflowing(el.scrollWidth > el.clientWidth);
	}, [text, width]);

	const content = (
		<span
			ref={ref}
			style={{
				display: "block",
				width,
				minWidth: width,
				maxWidth: width,
				overflow: "hidden",
				textOverflow: "ellipsis",
				whiteSpace: "nowrap",
				userSelect: "none",
			}}
		>
			{text}
		</span>
	);

	return (
		<TableCell sx={{ fontSize: "0.8rem", ...sx }} {...rest}>
			{isOverflowing ? (
				<Tooltip title={text} arrow placement="top">
					{content}
				</Tooltip>
			) : (
				content
			)}
		</TableCell>
	);
};

export const formatTons = (value: number | null | undefined): string => {
	if (value == null) return "-";
	return value.toLocaleString("en-US", {
		minimumFractionDigits: 0,
		maximumFractionDigits: 0,
	});
};

export const headerCellSx = {
	fontWeight: 600,
	backgroundColor: "#f5f5f5",
	borderBottom: "2px solid #e0e0e0",
	py: 1,
	fontSize: "0.8rem",
};

export const groupHeaderCellSx = {
	fontWeight: 700,
	backgroundColor: "#f5f5f5",
	borderBottom: "1px solid #e0e0e0",
	py: 1,
	fontSize: "0.8rem",
	textAlign: "center" as const,
};

export const bodyCellSx = { fontSize: "0.8rem" };
export const groupDividerSx = { borderLeft: "1px solid #e0e0e0" };
export const firstBodyCellSx = { ...bodyCellSx, ...groupDividerSx };
